<template>

    <CascoAjanlatBase :titleExtra="titleExtra"  v-if="false">

            <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

                <v-layout row wrap>

                </v-layout>

            </v-form>

    </CascoAjanlatBase>

</template>

<script>
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    name: 'AjanlatAdatokB9_V0',
    components: { CascoAjanlatBase },
    mixins: [cascoOfferData],
    methods: {},
    data() {
        return {
            // nincsenek bekerendo casco adatok
        };
    },
};
</script>
